import React from 'react';
import { WithChild } from '@keyslabor/shared/types';
import Box, { BoxProps } from '@keyslabor/shared/ui/layout/Box';
import Grid from '@keyslabor/shared/ui/layout/Grid';
import Header from '../Header';
import { headerHeight } from '@keyslabor/shared/constants';
import { LayoutProps } from 'styled-system';
import Row from '@keyslabor/shared/ui/layout/Row';
import { useIsMobile } from '@keyslabor/shared/hooks/useBreakPoint';

export interface OnSaveCallbackProps {
  newDate?: Date;
  routeChange?: boolean;
  navigationCallback?: () => void;
}

export interface UnsavedScheduleTracking {
  onSave: (data: OnSaveCallbackProps) => void;
  isChanged: boolean;
}

interface Props extends BoxProps {
  showHeader?: boolean;
  showBackButton?: boolean;
  unsavedScheduleTracking?: UnsavedScheduleTracking;
}

export default function PageLayout({
  showHeader = true,
  showBackButton = false,
  children,
  unsavedScheduleTracking,
  ...rest
}: WithChild<Props & LayoutProps>) {
  const isMobile = useIsMobile();

  return (
    <Grid
      gridAutoFlow="row"
      gridAutoRows={showHeader ? `${headerHeight}px 1fr` : '1fr'}
      minHeight="100%"
    >
      {showHeader && (
        <Box width="100%" position="relative" height={`${headerHeight}px`}>
          <Header
            unsavedScheduleTracking={unsavedScheduleTracking}
            showBackButton={showBackButton}
          />
        </Box>
      )}
      <Row
        overflowY={isMobile ? 'auto' : undefined}
        // height={isMobile ? `calc(100% - ${px(headerHeight)})` : '100%'}

        // minHeight="100%"
        wide
        gridAutoRows="auto"
        {...rest}
      >
        {children}
      </Row>
    </Grid>
  );
}
